// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"y3eNxRzSZSFgR-sYf9aMs"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Announcer/Announcer.css
// module id = 1144
// module chunks = 58